<template>
  <div>
    <b-card
      :title="readMode && !observers.length ? 'No hay observadores registrados' : 'Observadores'"
      class="scroll"
      :class="{ 'minHeigth' : !readMode }"
    >
      <form data-vv-scope="observer-form" v-on:submit.prevent >
        <div class="row" v-if="!readOnly">
          <div class="col-11">
            <ListUser
              class="w-100 mb-0"
              autocomplete
              label="Nombre del observador"
              name="user"
              v-model="user"
              data-vv-as="usuario"
              :danger="errors.has('observer-form.user')"
              :danger-text="errors.first('observer-form.user')"
              v-validate="'required'"
              @full-user="observer = $event"
            />
            <small class="text-danger mb-5" v-if="repeated">Usuario ya elegido</small>
          </div>
          <div class="col-3 mt-5">
            <vs-checkbox
              data-cy="notification"
              v-model="notification"
              class="mt-5 w-100"
              color="primary"
              v-tooltip="'Marca si quiere recibir una notificación'"
            >
              Notificación
            </vs-checkbox>
          </div>
          <div class="col-1 mt-3">
            <vs-icon
              class="mt-5 w-100 cursor-pointer"
              icon="add_circle_outline"
              size="medium"
              v-tooltip="'Agregar observador'"
              color="success"
              @click="addObserver"
              data-cy="add-observer"
            />
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12">
            <b-table
              small
              class="text-center" v-if="observers.length"
              :items="observers" :fields="fields"
            >
              <template #cell(notificar)="{ item }">
                <span class="badge badge-success" v-if="item.notificar">Si</span>
                <span class="badge badge-warning" v-else>No</span>
              </template>
              <template #cell(action)="{ item }">
                <vs-icon
                  v-if="!readOnly"
                  class="mt-5 w-100 cursor-pointer"
                  icon="remove_circle_outline"
                  size="medium"
                  v-tooltip="'Eliminar observador'"
                  color="danger"
                  @click="removeObserver(item.observador)"
                />
              </template>
            </b-table>
          </div>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ListUser from '@/febos/chile/lists/components/ListUser';

export default {
  name: 'Observers',
  components: { ListUser },
  props: ['readOnly'],
  data() {
    return {
      user: null,
      observer: null,
      notification: false,
      observers: [],
      fields: [
        { key: 'observador', label: 'Nombre' },
        { key: 'notificar', label: 'Notificación' },
        { key: 'action', label: '', class: this.getClass() }
      ],
      repeated: false
    };
  },
  watch: {
    user() {
      this.repeated = false;
    },
    observers() {
      this.$emit('observers', this.observers);
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'aprovalTemplate'
    ]),
    readMode() {
      return this.readOnly;
    }
  },
  methods: {
    getClass() {
      return this.$route.params.view === 'see' ? 'd-none' : '';
    },
    async addObserver() {
      this.repeated = false;
      const isValid = await this.$validator.validateAll('observer-form');
      if (!isValid) return;

      const alreadySelected = this.observers.find((item) => item.observadorUsuarioId === this.user);
      if (alreadySelected) {
        this.repeated = true;
        return;
      }
      this.observers.push({
        observador: this.observer.label,
        observadorUsuarioId: this.observer.id,
        notificar: this.notification
      });
      this.notification = false;
    },
    removeObserver(observer) {
      this.observers = this.observers.filter((o) => o.observador !== observer);
    }
  },
  created() {
    if (this.$route.params.view !== 'create') {
      this.observers = this.aprovalTemplate.observadores;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "steps";

</style>
